export const walletIcon = {
    width: '90%',
    height: '90%',
    color1: '#2CB095',
    color2: '#057A83',
};
